import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { StatusBadge } from '../StatusBadge';

import * as styles from './CertificateStatusBlock.module.css';

import type { Coverage } from '../../types/Policy';

export const CertificateStatusBlock: React.FC<{
  waitingCertificate: boolean;
  coverage: Coverage | undefined;
  className?: string;
}> = ({ waitingCertificate, coverage, className = '' }) => {
  const { t } = useTranslation('policy');
  return waitingCertificate || coverage === undefined ? (
    <div className={clsx(styles.processingCertificate, className)}>{t('processing_certificate')}</div>
  ) : (
    <StatusBadge.Policy status={coverage.status} className={className} />
  );
};
